import { goalCollections } from 'constants/analytics';
import { AnalyticsTarget } from 'enums/AnalyticsTarget';

export type ReachGoalEvents = typeof reachGoalEvents;
export const reachGoalEvents = {
    [AnalyticsTarget.SHOW_NO_CONNECTION]: () => [
        goalCollections.SHOW_POPUP,
        goalCollections.CHAT_STATUSES,
        'Подключение отсутствует',
    ],
    [AnalyticsTarget.SHOW_CONNECTION]: () => [
        goalCollections.SHOW_POPUP,
        goalCollections.CHAT_STATUSES,
        'Подключен',
    ],

    [AnalyticsTarget.CLICK_ATTACH]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Нажатие на кнопку прикрепления файла. Скрепка',
    ],
    [AnalyticsTarget.SHOW_CHAT_MAX_TEXT_LENGTH]: () => [
        goalCollections.SHOW_POPUP,
        goalCollections.CHAT_STATUSES,
        'Ошибка слишком длинный текст',
    ],
    [AnalyticsTarget.SHOW_PENDING_MESSAGE]: () => [
        goalCollections.SHOW_POPUP,
        goalCollections.CHAT_STATUSES,
        'Ошибка отправки сообщения',
    ],
    [AnalyticsTarget.SHOW_FILE_NOT_UPLOADED]: () => [
        goalCollections.SHOW_POPUP,
        goalCollections.CHAT_STATUSES,
        'Ошибка отправки файл',
    ],
    [AnalyticsTarget.CLICK_FILES_SEND]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Отправка файла',
    ],
    [AnalyticsTarget.CLICK_HOVERING_BUTTON]: (goal: string) => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        goal,
    ],

    [AnalyticsTarget.CLICK_TO_FAVORITES]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Нажатие на кнопку В избранное',
    ],
    [AnalyticsTarget.CLICK_FROM_FAVORITES]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Нажатие на кнопку Из избранного',
    ],
    [AnalyticsTarget.CLICK_BUTTON_SETTINGS_FAVORITES]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Нажатие на кнопку Избранные сообщения',
    ],
    [AnalyticsTarget.CLICK_FAVORITES_GO_TO_HISTORY]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Нажатие на кнопку Перейти к истории',
    ],

    [AnalyticsTarget.CLICK_COPY]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Нажатие на кнопку Копировать',
    ],
    [AnalyticsTarget.CLICK_REPLY]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Клик по кнопке Ответить',
    ],
    [AnalyticsTarget.CLICK_QUOTE_SEND]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Отправка сообщения с цитатой',
    ],

    [AnalyticsTarget.CLICK_HISTORY_DATE]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Нажатие на дату в истории',
    ],
    [AnalyticsTarget.SHOW_DATEPICKER_OPEN]: () => [
        goalCollections.SHOW_POPUP,
        goalCollections.CHAT_ACTIONS,
        'Открытие календаря',
    ],
    [AnalyticsTarget.SHOW_DATEPICKER_CLOSE]: () => [
        goalCollections.SHOW_POPUP,
        goalCollections.CHAT_ACTIONS,
        'Закрытие календаря',
    ],
    [AnalyticsTarget.CLICK_DATEPICKER_DATE]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Нажатие на дату в календаре',
    ],

    [AnalyticsTarget.CLICK_BUTTON_UNAUTHORIZED_WIDGET]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_PAGE_UNAUTHORIZED_ZONE,
        'Нажатие на кнопку чата в неавторизованной зоне',
    ],
    [AnalyticsTarget.CLICK_OPEN_CHAT]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Открытие чата',
    ],
    [AnalyticsTarget.SHOW_INITIAL_HISTORY]: () => [
        goalCollections.SHOW_POPUP,
        goalCollections.CHAT_ACTIONS,
        'Загрузка истории после открытия чата',
    ],
    [AnalyticsTarget.SHOW_CHAT_NOTIFICATIONS]: () => [
        goalCollections.SHOW_POPUP,
        goalCollections.CHAT_ACTIONS,
        'Push-уведомление о новом сообщении в чате',
    ],
    [AnalyticsTarget.CLICK_ROLL_CHAT]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Нажатие на кнопку Развернуть виджет',
    ],
    [AnalyticsTarget.CLICK_UNROLL_CHAT]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Нажатие на кнопку Свернуть виджет',
    ],

    [AnalyticsTarget.CLICK_QUICK_ACTIONS_MENU_OPEN]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT,
        'Нажатие на кнопку Меню Быстрых Операций для открытия меню',
    ],
    [AnalyticsTarget.CLICK_QUICK_ACTIONS_MENU_CLOSE]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT,
        'Нажатие на кнопку Меню Быстрых Операций для закрытия меню',
    ],
    [AnalyticsTarget.CLICK_QUICK_ACTIONS_MENU_OUTWARD_CLOSE]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT,
        'Нажатие на свободное поле для закрытия меню',
    ],
    [AnalyticsTarget.CLICK_QUICK_ACTIONS_MENU_SELECT]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_PAGE_QUICK_ACTIONS_MENU,
        'Нажатие на кнопку в Меню Быстрых Операций',
    ],
    [AnalyticsTarget.CLICK_QUICK_ACTIONS_MENU_BACK]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT,
        'Нажатие на кнопку назад',
    ],

    [AnalyticsTarget.CLICK_HEADER_CHAT]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Нажатие на хэдер чата',
    ],
    [AnalyticsTarget.CLICK_BUTTON_MEDIA_LINKS]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_PAGE_MENU,
        'Нажатие на кнопку Ссылки',
    ],
    [AnalyticsTarget.CLICK_BUTTON_MEDIA_IMAGES]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_PAGE_MENU,
        'Нажатие на кнопку Фото',
    ],
    [AnalyticsTarget.CLICK_BUTTON_MEDIA_FILES]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_PAGE_MENU,
        'Нажатие на кнопку Файлы',
    ],

    [AnalyticsTarget.CLICK_CHAT_MENU]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Нажатие на кнопку Меню чата',
    ],
    [AnalyticsTarget.CLICK_BUTTON_SETTINGS_CHAT]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_PAGE_SETTINGS,
        'Нажатие на кнопку Настройки чата',
    ],
    [AnalyticsTarget.CLICK_TOGGLE_SETTING_NOTIFICATIONS]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_PAGE_SETTINGS,
        'Нажатие на кнопку Уведомления',
    ],
    [AnalyticsTarget.CLICK_TOGGLE_SETTING_TIME_N_STATUS]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_PAGE_SETTINGS,
        'Нажатие на кнопку Время и статус сообщений',
    ],
    [AnalyticsTarget.CLICK_TOGGLE_SETTING_VIBRATION]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_PAGE_SETTINGS,
        'Нажатие на кнопку Виброотклик',
    ],
    [AnalyticsTarget.CLICK_COLOR_SCHEME_N1]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_PAGE_SETTINGS,
        'Нажатие на кнопку 1-й цветовой схемы',
    ],
    [AnalyticsTarget.CLICK_COLOR_SCHEME_N2]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_PAGE_SETTINGS,
        'Нажатие на кнопку 2-й цветовой схемы',
    ],
    [AnalyticsTarget.CLICK_COLOR_SCHEME_N3]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_PAGE_SETTINGS,
        'Нажатие на кнопку 3-й цветовой схемы',
    ],
    [AnalyticsTarget.CLICK_COLOR_SCHEME_N4]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_PAGE_SETTINGS,
        'Нажатие на кнопку 4-й цветовой схемы',
    ],
    [AnalyticsTarget.CLICK_MEDIA_GO_TO_HISTORY]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_PAGE_GALLERY_CONTENT,
        'Нажатие на кнопку Перейти к сообщению',
    ],

    [AnalyticsTarget.SHOW_AGENT_ACHIEVEMENTS]: () => [
        goalCollections.SHOW_POPUP,
        goalCollections.CHAT_ACTIONS,
        'Открытие экрана отметок бота / оператора',
    ],
    [AnalyticsTarget.SHOW_CHAT_STATUS]: (error: string) => [
        goalCollections.SHOW_POPUP,
        goalCollections.CHAT_STATUSES,
        error,
    ],

    [AnalyticsTarget.CLICK_PREDICTIVE_INPUT_TIPS]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_SCREEN_WITH_PREDICTIVE_INPUT_TIPS,
        'Нажатие на подсказке предиктивного ввода',
    ],
    [AnalyticsTarget.SHOW_PREDICTIVE_INPUT_TIPS]: () => [
        goalCollections.SHOW_POPUP,
        goalCollections.CHAT_SCREEN,
        'Подсказки предиктивного ввода',
    ],

    [AnalyticsTarget.CLICK_VOICE_START]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_SCREEN,
        'Голосовое сообщение. Старт',
    ],
    [AnalyticsTarget.CLICK_VOICE_CANCEL]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_SCREEN,
        'Голосовое сообщение. Отмена записи',
    ],
    [AnalyticsTarget.CLICK_VOICE_SEND]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_SCREEN,
        'Голосовое сообщение. Отправка сообщения',
    ],
    [AnalyticsTarget.CLICK_VOICE_LIMIT]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_SCREEN,
        'Голосовое сообщение. Лимит',
    ],
    [AnalyticsTarget.CLICK_VOICE_TRANSCRIPT]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_SCREEN,
        'Голосовое сообщение. Транскрибация',
    ],

    [AnalyticsTarget.CLICK_ADD_REACTION]: (name: string) => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_SCREEN,
        'Добавление реакции',
        name,
    ],
    [AnalyticsTarget.CLICK_REMOVE_REACTION]: (name: string) => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_SCREEN,
        'Удаление реакции',
        name,
    ],

    [AnalyticsTarget.SHOW_GAME_COIN]: () => [
        goalCollections.WATCH_SCREEN,
        goalCollections.CHAT_ACTIONS,
        'Экран с монеткой для старта игры',
    ],
    [AnalyticsTarget.CLICK_GAME_COIN]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Нажатие на монетку для старта игры',
    ],
    [AnalyticsTarget.CLICK_GAME_PLAY]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Начало игры. Нажатие на кнопку Играть',
    ],
    [AnalyticsTarget.CLICK_GAME_CANCEL]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Начало игры. Нажатие на кнопку Отменить',
    ],
    [AnalyticsTarget.CLICK_GAME_REPLAY]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Копилка разбилась. Нажатие на кнопку Играть',
    ],
    [AnalyticsTarget.CLICK_GAME_EXIT]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Копилка разбилась. Нажатие на кнопку Выйти',
    ],
    [AnalyticsTarget.CLICK_GAME_CLOSE]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'В игре. Нажатие на кнопку Закрыть крестик',
    ],
    [AnalyticsTarget.CLICK_GAME_PAUSE]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'В игре. Нажатие на кнопку Пауза',
    ],
    [AnalyticsTarget.CLICK_GAME_RESUME]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'На паузе. Нажатие на кнопку Играть',
    ],
    [AnalyticsTarget.CLICK_GAME_LEAVE]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'На паузе. Нажатие на кнопку Закрыть крестик',
    ],
    [AnalyticsTarget.SHOW_GAME_RECORDS]: () => [
        goalCollections.WATCH_SCREEN,
        goalCollections.CHAT_ACTIONS,
        'Экран таблицы рекордов',
    ],
    [AnalyticsTarget.CLICK_GAME_PLAY_AGAIN]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Нажатие на кнопку Играть еще раз',
    ],

    [AnalyticsTarget.CLICK_BUTTON_SETTINGS_SEARCH]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Нажатие на кнопку Поиск лупа',
    ],
    [AnalyticsTarget.CLICK_SEARCH_QUERY]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Поиск по введенному запросу',
    ],
    [AnalyticsTarget.SHOW_SEARCH_FIRST]: () => [
        goalCollections.WATCH_SCREEN,
        goalCollections.CHAT_ACTIONS,
        'Переход к первому результату поиска',
    ],
    [AnalyticsTarget.CLICK_SEARCH_NAVBAR]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Нажатие на кнопку навигации по результатм поиска стралка вверх и стрелка внизу',
    ],
    [AnalyticsTarget.CLICK_SEARCH_SCROLL_TO_BOTTOM]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Нажатие на кнопку пролистывания к последнему сообщению',
    ],

    [AnalyticsTarget.CLICK_BUTTON_SETTINGS_DOWNLOAD_HISTORY]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Сохранить историю переписки',
    ],
    [AnalyticsTarget.CLICK_DOWNLOAD_HISTORY_AS_HTML]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Нажатие на кнопку Текст и файлы',
    ],
    [AnalyticsTarget.CLICK_DOWNLOAD_HISTORY_AS_TEXT]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Нажатие на кнопку Только текст',
    ],

    [AnalyticsTarget.SHOW_BOT_REPLAY_LOADER]: () => [
        goalCollections.WATCH_SCREEN,
        goalCollections.CHAT_SCREEN,
        'Показ лодера',
    ],

    [AnalyticsTarget.SHOW_INFORMATION_BANNER]: () => [
        goalCollections.SHOW_POPUP,
        goalCollections.CHAT_SCREEN,
        'Инфобаннер',
    ],

    [AnalyticsTarget.CONNECTION_TOOK_TO_LONG]: () => [
        goalCollections.SHOW_POPUP,
        goalCollections.CHAT_SCREEN,
        'Долгое подключение к чату',
    ],

    [AnalyticsTarget.SHOW_CSI_FORM]: () => [
        goalCollections.SHOW_WIDGET,
        goalCollections.CHAT_SCREEN,
        'CSI. Форма оценки',
    ],
    [AnalyticsTarget.SHOW_CSI_FEEDBACK_FORM]: () => [
        goalCollections.SHOW_WIDGET,
        goalCollections.CHAT_SCREEN,
        'CSI. Поле ввода комментария',
    ],
    [AnalyticsTarget.CLICK_CSI_FORM_SUBMIT_NO_RATING]: () => [
        goalCollections.SHOW_WIDGET,
        goalCollections.CHAT_SCREEN,
        'CSI. Ошибка. Не поставлена оценка.',
    ],
    [AnalyticsTarget.CLICK_CSI_FORM_SUBMIT]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_SCREEN,
        'CSI. Нажатие на кнопку Отправить',
    ],
    [AnalyticsTarget.CLICK_CSI_FORM_CLOSE]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_SCREEN,
        'CSI. Нажатие на кнопку Закрыть',
    ],

    [AnalyticsTarget.SHOW_AWAIT_TIME_INDICATOR]: () => [
        goalCollections.SHOW_POPUP,
        goalCollections.CHAT_SCREEN,
        'Таймер ожидания',
    ],

    [AnalyticsTarget.SHOW_UNAUTH_START_SCREEN]: () => [
        goalCollections.SHOW_POPUP,
        goalCollections.CHAT_SCREEN,
        'Экран чата в неавторизованной зоне',
    ],

    [AnalyticsTarget.CLICK_VK_MESSENGER]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_SCREEN,
        'Нажатие на VK',
    ],

    [AnalyticsTarget.CLICK_WHATSAPP_MESSENGER]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_SCREEN,
        'Нажатие на Whatsapp',
    ],

    [AnalyticsTarget.CLICK_VIBER_MESSENGER]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_SCREEN,
        'Нажатие на Viber',
    ],

    [AnalyticsTarget.CLICK_TELEGRAM_MESSENGER]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_SCREEN,
        'Нажатие на Telegram',
    ],

    [AnalyticsTarget.SHOW_SURVEY_WIDGET]: (type) => [
        goalCollections.SURVEY,
        goalCollections.SHOW_WIDGET,
        goalCollections.CHAT_SCREEN,
        goalCollections.SURVEY_SHOW,
        type,
    ],

    [AnalyticsTarget.SURVEY_WIDGET_VALIDATION_ERROR]: () => [
        goalCollections.SURVEY,
        goalCollections.ERRORS,
        goalCollections.CHAT_SCREEN,
        `Ошибка валидации поля ответа`,
    ],

    [AnalyticsTarget.SURVEY_WIDGET_CLOSE]: () => [
        goalCollections.SURVEY,
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_SCREEN,
        'Закрытие опроса в чате',
    ],

    [AnalyticsTarget.SURVEY_WIDGET_REPLY]: () => [
        goalCollections.SURVEY,
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_SCREEN,
        'Клик на кнопку Ответить',
    ],

    [AnalyticsTarget.SURVEY_WIDGET_CHOOSING_RESPONSE]: () => [
        goalCollections.SURVEY,
        goalCollections.CHOOSING_VALUE,
        goalCollections.CHAT_SCREEN,
        'Выбор оценки или ответа',
    ],

    [AnalyticsTarget.CONNECTION_ERROR]: (error = '') => [
        goalCollections.ERRORS,
        goalCollections.CHAT_SCREEN,
        goalCollections.DISCONNECTED,
        error,
    ],

    [AnalyticsTarget.AwaitTimeInSeconds]: (seconds = '') => [
        goalCollections.SHOW_WIDGET,
        goalCollections.CHAT_SCREEN,
        'Время ответа оператора в чате в секундах',
        seconds,
    ],

    // прогноз, факт, дельта, проценты

    [AnalyticsTarget.AwaitTimeInPercent]: (percent = '') => [
        goalCollections.SHOW_WIDGET,
        goalCollections.CHAT_SCREEN,
        'Время ответа оператора в чате в процентах',
        percent,
    ],

    [AnalyticsTarget.OperatorReactions]: () => [
        goalCollections.CLICK_ON_BUTTON,
        goalCollections.CHAT_ACTIONS,
        'Реакция от оператора',
    ],
};
